jQuery(function ($) {
  let filters = window.legacyFindALabFilters || '';
  $.get(`${process.env.API_URL}/api/v1/labsNear?filters=${filters}`, function (response) {
    $('#location_count').text(response.length);

    for (let i = 0; i < response.length; i++) {
      document
        .getElementById('location_container_' + ((i % 3) + 1))
        .appendChild(createElementFromHTML(tmpl('lab_location', response[i])));
    }
  });
});
